var _g, _path, _rect, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15474_117995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 5.17157 12.6716 4.5 13.5 4.5H34.5L45 15V42C45 42.8284 44.3284 43.5 43.5 43.5H13.5C12.6716 43.5 12 42.8284 12 42V6Z",
    fill: "#BA2417"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 33,
    width: 16.5,
    height: 10.5,
    fill: "#BA2417"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 33,
    width: 16.5,
    height: 10.5,
    fill: "#BA2417"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 15H36C35.1716 15 34.5 14.3284 34.5 13.5V4.5L39.75 9.75L45 15Z",
    fill: "white",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19.5,
    width: 27,
    height: 15,
    rx: 1.5,
    fill: "#EC5649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7971 24.9362H23.7771V26.8082H27.7131V28.2122H23.7771V31.5002H22.2051V23.5322H27.7971V24.9362Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6855 23.5322H16.4455C19.2175 23.5322 20.7895 25.3442 20.7895 27.5162C20.7895 29.6882 19.2175 31.5002 16.4455 31.5002H13.6855V23.5322ZM15.2575 30.0962H16.3975C18.1255 30.0962 19.2175 29.0162 19.2175 27.5162C19.2175 26.0162 18.1255 24.9362 16.3975 24.9362H15.2575V30.0962Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3308 25.9802C12.3308 27.3122 11.4668 28.4402 9.57077 28.4402H7.20677V31.5002H5.63477V23.5322H9.57077C11.4668 23.5322 12.3308 24.6722 12.3308 25.9802ZM7.20677 24.9362V27.0362H9.46277C10.2788 27.0362 10.7588 26.6162 10.7588 25.9802C10.7588 25.3442 10.2788 24.9362 9.46277 24.9362H7.20677Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15474_117995"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4.5,
    width: 33,
    height: 39,
    rx: 1.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.36871191ceb1039e39f15ccbb1034bd6.svg";
export { ForwardRef as ReactComponent };